import { render } from "./SectionWhiteCube.vue?vue&type=template&id=2ec4e93d&scoped=true"
import script from "./SectionWhiteCube.vue?vue&type=script&lang=js"
export * from "./SectionWhiteCube.vue?vue&type=script&lang=js"

import "./SectionWhiteCube.vue?vue&type=style&index=0&id=2ec4e93d&scoped=true&lang=stylus"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ec4e93d"]])

export default __exports__